import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import routes from '@/router/routes';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	routes,
});

const runBefore = async(to, from) => {
	const continueLeadToken = to.query['lead-token'];
	const stateQuote = store.state.quote;
	let quote = {};

	Vue.$log.debug('runBefore | ', to, from, store);

	if (continueLeadToken) {
		Vue.$log.info('continue | ', continueLeadToken);

		return {};
	}

	// If the quote data hasn't already been loaded, then attempt to
	// load it and wait for it to complete before next step
	try {
		if (to.name && !stateQuote.tokens.move) {
			if (to.query.external) {
				store.commit('TOGGLE_IFRAME', to.query.external);
			}

			quote = await store.dispatch('quote/init', to);
			Vue.$log.info('router-quote', quote);
		}
	} catch (err) {
		Vue.$log.error('quote/init->', err);
	}

	// No need to run any validation when user is going to 'home' page
	if (to.path === '/' || to.name === 'home') {
		return {};
	}

	// Validate that the user is allowed on this route and redirect if
	// they don't have required data
	try {
		const validRoute = stateQuote.isContinue || store.getters['progress/isValidRoute'](to);

		Vue.$log.debug('validRoute->', validRoute);

		if (!validRoute) {
			Vue.$log.warn(`User not allowed on this route: ${to.name}`);

			return { name: 'home' };
		}

		if (to.name === 'thank-you' && !stateQuote.firstName) {
			return { name: 'home' };
		}
	} catch (err) {
		Vue.$log.error('validateRoute->', err);

		return { name: 'home' };
	}

	return {};
};

router.beforeEach(async(to, from, next) => {
	const newRoute = await runBefore(to, from);
	const query = Object.values(from.query).length ? from.query : to.query;

	Vue.$log.debug(
		'beforeEach | newRoute->',
		newRoute,
		'from.query->',
		from.query,
		'to.query->',
		to.query,
		'query->',
		query
	);

	const withQuery = Object.assign({}, newRoute, { query });

	Vue.$log.debug('beforeEach | withQuery->', withQuery);

	next(withQuery);
});

export default router;
